import styled from 'styled-components';

export const Button = styled.button`
  background-color: var(--primary-color);
  color: white;
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  display: inline-block;
  text-align: center;
  
  &:hover {
    background-color: #e05e00;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  margin-bottom: 2rem;
  text-align: center;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: #222;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1.5rem;
  }
  
  @media (max-width: 480px) {
    font-size: 2rem;
    margin-bottom: 1.25rem;
    line-height: 1.3;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.3rem;
  color: #555;
  text-align: center;
  max-width: 900px;
  margin: 0 auto 4rem auto;
  line-height: 1.7;
  font-weight: 400;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin: 0 auto 3rem auto;
    max-width: 90%;
    line-height: 1.6;
  }
  
  @media (max-width: 480px) {
    font-size: 1.1rem;
    margin: 0 auto 2.5rem auto;
    max-width: 95%;
    line-height: 1.6;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  
  &.column {
    flex-direction: column;
  }
  
  &.center {
    align-items: center;
    justify-content: center;
  }
  
  &.space-between {
    justify-content: space-between;
  }
`;

export const Card = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  }
`;

export const InputField = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  font-size: 1rem;
  
  &:focus {
    outline: none;
    border-color: var(--primary-color);
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
`;

export const Section = styled.section`
  padding: 7rem 0;
  
  &.light {
    background-color: var(--light-gray);
  }
  
  @media (max-width: 768px) {
    padding: 5rem 0;
  }
  
  @media (max-width: 480px) {
    padding: 4rem 0;
  }
`; 